import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Star, MapPin, Clock } from 'lucide-react';
import namkeFallback from '../../assets/namke-fallback.png';

const SimilarRestaurants = ({ restaurants = [], currentRestaurantId }) => {
  const { t } = useTranslation();
  if (!restaurants || restaurants.length === 0) {
    return null;
  }

  return (
    <div className="mt-8">
      <h3 className="text-2xl font-bold mb-6" style={{ color: 'rgb(5, 70, 37)' }}>
        {t('restaurant.similarRestaurants')}
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {restaurants
          .filter(restaurant => restaurant.id !== currentRestaurantId)
          .slice(0, 6)
          .map((restaurant) => (
            <Link
              key={restaurant.id}
              to={`/restaurant/${restaurant.id}`}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-shadow duration-300"
            >
              <div className="relative h-48">
                <img
                  src={restaurant.profile?.banner_image_url || restaurant.profile?.logo_url || namkeFallback}
                  alt={restaurant.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = namkeFallback;
                  }}
                />
              </div>
              
              <div className="p-4">
                <h4 className="font-bold text-lg mb-2" style={{ color: 'rgb(5, 70, 37)' }}>
                  {restaurant.name}
                </h4>
                
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex items-center">
                    <Star size={16} className="fill-current" style={{ color: 'rgb(5, 70, 37)' }} />
                  </div>
                  <span className="text-sm font-medium" style={{ color: 'rgb(5, 70, 37)' }}>
                    {restaurant.rating != null ? Number(restaurant.rating).toFixed(1) : '—'}
                  </span>
                </div>
                
                <div className="flex items-center gap-2 mb-2">
                  <MapPin size={16} style={{ color: 'rgb(5, 70, 37)' }} />
                  <span className="text-sm text-gray-600">{restaurant.city || '—'}</span>
                </div>
                
                <div className="flex items-center gap-2">
                  <Clock size={16} style={{ color: 'rgb(5, 70, 37)' }} />
                  <span className="text-sm text-gray-600">
                    {restaurant.is_active === false ? t('restaurant.closed') : t('restaurant.open')}
                  </span>
                </div>
              </div>
            </Link>
          ))}
      </div>
    </div>
  );
};

export default SimilarRestaurants;



